export default {
  // 搜索区域
  typePlaceholder: 'Enter type (Drone/Dog/Robot)',
  topicPlaceholder: 'Enter topic',
  searchButton: 'Search',
  addTopic: 'Add Topic',

  // 表格列
  typeColumn: 'Type',
  topicColumn: 'Topic',
  createTimeColumn: 'Create Time',
  actionColumn: 'Action',

  // 表单字段
  typeLabel: 'Type',
  topicLabel: 'Topic',
  typeSelectPlaceholder: 'Please select type',
  topicInputPlaceholder: 'e.g. thing/product/dog/ROBOT_DOG_006/event',

  // 按钮
  deleteButton: 'Delete',
  cancelButton: 'Cancel',
  confirmButton: 'Confirm',

  // 验证提示
  typeRequired: 'Please select type',
  topicRequired: 'Please enter topic',

  // 消息提示
  deleteConfirm: 'Delete {topic}?',
  deleteSuccess: 'Deleted successfully',
  addSuccess: 'Added successfully',

  // 设备类型
  drone: 'Drone',
  dog: 'Dog',
  robot: 'Robot',

  // 弹窗标题
  addTopicTitle: 'Add Topic',
}
